import { useRef } from 'react';
import type { Mode } from '../lib/types';

export function ChatInput({
  value,
  onChange,
  onSend,
  onUpload,
  loading,
  mode,
}: {
  value: string;
  onChange: (v: string) => void;
  onSend: () => void;
  onUpload: (file: File) => void;
  loading: boolean;
  mode: Mode;
}) {
  const fileRef = useRef<HTMLInputElement>(null);

  function onKeyDown(e: React.KeyboardEvent<HTMLTextAreaElement>) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSend();
    }
  }

  return (
    <div className="composer">
      <button
        className="icon-btn"
        title="Bestand uploaden (pdf, docx, txt)"
        onClick={() => fileRef.current?.click()}
        disabled={loading}
      >
        📎
      </button>
      <input
        ref={fileRef}
        type="file"
        accept=".pdf,.docx,.txt,.md"
        hidden
        onChange={(e) => {
          const f = e.target.files?.[0];
          if (f) onUpload(f);
          e.target.value = '';
        }}
      />
      <textarea
        className="composer-input"
        placeholder={mode === 'draft' ? 'Plak een klant-e-mail…' : 'Typ een vraag…'}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={onKeyDown}
        rows={2}
        disabled={loading}
      />
      <button className="send-btn" onClick={onSend} disabled={loading || !value.trim()}>
        →
      </button>
    </div>
  );
}
